import React from 'react';
import { List, Filter, AutocompleteInput, Datagrid, TextField, DateField, ReferenceField, EditButton } from 'react-admin';
import { Edit, SimpleForm, SelectInput, TextInput, ReferenceInput, DateInput } from 'react-admin';
import { Create } from 'react-admin';
import { Show, TabbedShowLayout, ReferenceManyField, Tab, ShowButton, required } from 'react-admin';
import Pagination from '../common/Pagination'

const CustomerFilter = props => (
  <Filter {...props}>
    <ReferenceInput label="Customer name" source="id" reference="customers" filterToQuery={searchText => ({ name: searchText })}  sort={{ field: 'name', order: 'ASC' }}><AutocompleteInput optionText="name" /></ReferenceInput>
  </Filter>
);

export const CustomerList = props => (
  <List filters={<CustomerFilter/>} {...props} pagination={<Pagination />} perPage={50}>
    <Datagrid rowClick="show">
      <TextField source="name" />
      <DateField source="created_at" />
      <DateField source="updated_at" />
      <EditButton />
    </Datagrid>
  </List>
);

export const CustomerEdit = props => (
  <Edit title={<CustomerTitle/>}{...props}>
    <SimpleForm redirect="show" >
      <TextInput source="name" validate={required("Name is required")}/>
    </SimpleForm>
  </Edit>
);

export const CustomerCreate = props => (
  <Create {...props}>
    <SimpleForm redirect="show" >
      <TextInput source="name" validate={required("Name is required")}/>
    </SimpleForm>
  </Create>
);

const CustomerTitle = ({record}) => {
  return <span>Customer - { record ? `${record.name}` : ''}</span>
}

export const CustomerShow = props => (
  <Show title={<CustomerTitle/>} {...props}>
    <TabbedShowLayout>
      <Tab label="Details">
        <TextField source="name" />
        <DateField source="created_at" />
        <DateField source="updated_at" />
      </Tab>
      <Tab label="Projects">
        <ReferenceManyField
          addLabel={false}
          reference="projects"
          source="id"
          target="customer_id"
          sort={{ field: 'updated_at', order: 'DESC' }}
        >
          <Datagrid>
            <ReferenceField label="Name" source="id" reference="projects" link="show"><TextField source="name" /></ReferenceField>
            <DateField source="created_at" />
            <DateField source="updated_at" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);
